import {
    SOCKET_NEW_MESSAGE,
    SHOW_POPUP
} from '../constants/action-types';
import { getMarketLog, updateOrderIfOpen, marketOrderNotifikation, removeMarketOrderNotifikation } from '../actions/marketsActions';
import { getOrders } from '../actions/ordersActions';

const newAudio = new Audio("/sound/new_order.wav");
const relatedTradedAudio = new Audio("/sound/related_order_traded.wav");
const tradedAudio = new Audio("/sound/order_traded.wav");


const getAllProductsFromViews = (views) => {
    let product_ids = [];

    views.forEach((view) => {
        product_ids = product_ids.concat(view.args.include.products);
    })

    return [...new Set(product_ids)];
}

const playSound = (dispatch, pathName, product_id, views) => {
    const marketLogArgs = JSON.parse( localStorage.getItem('marketLogArgs') );
    const volumeOn = JSON.parse(localStorage.getItem('volumeOn')) == null ? true : JSON.parse(localStorage.getItem('volumeOn'));
    const product_ids = getAllProductsFromViews(views);

    if (pathName == '/onlinemarkets' && marketLogArgs) {
        //const products = marketLogArgs.include.products;

        if (product_ids.find(id => id === product_id)) {
            dispatch(marketOrderNotifikation({product_id: product_id, date: new Date()}));

            return volumeOn;
        }
    } 
    return false;
}


export default function socketMiddleware(socket) {
    // Socket param is the client. We'll show how to set this up later.
    return ({ dispatch, getState }) => next => action => {
        if (typeof action === 'function') {
            return action(dispatch, getState);
        }

        /*
         * Socket middleware usage.
         * promise: (socket) => socket.emit('MESSAGE', 'hello world!')
         * type: always 'socket'
         * types: [REQUEST, SUCCESS, FAILURE]
         */
        const { promise, type, types, ...rest } = action;



        if (type !== 'socket' || !promise) {
            // Move on! Not a socket request or a badly formed one.
            return next(action);
        }

        const [REQUEST, SUCCESS, FAILURE] = types;
        next({ ...rest, type: REQUEST });


        return promise(socket)
            .then(socketClient => {
                socketClient.on('update', (orderId) => {
                    dispatch({
                        type: SOCKET_NEW_MESSAGE,
                        data: orderId
                    });
                    let marketLogArgs = JSON.parse( localStorage.getItem('marketLogArgs') );
                    let pathname = getState().routing.locationBeforeTransitions.pathname;

                    switch (pathname) {
                        case '/onlinemarkets':
                            if (orderId) {
                                dispatch(updateOrderIfOpen(orderId));
                            }
                            if (marketLogArgs) dispatch(getMarketLog(marketLogArgs));
                            break;
                        case '/yourworkingorders':
                            dispatch(getOrders('workingOrders'));
                            break;
                        case '/youropenpositions':
                            dispatch(getOrders('openPositions'));
                            break;
                        case '/yoursettledtrades':
                            dispatch(getOrders('settledTrades'));
                            break;
                        case '/lasttraded':
                            dispatch(getOrders('lastTraded'));
                            break;
                    }
                });

                socketClient.on('new_order', (product_id) => {
                    const pathname = getState().routing.locationBeforeTransitions.pathname;
                    const views = getState().user.userInfo.views;

                    if (playSound(dispatch, pathname, product_id, views)) {
                        newAudio.play();
                       
                    }
                });

                socketClient.on('related_users_order_traded', (product_id) => {
                    const pathname = getState().routing.locationBeforeTransitions.pathname;
                    const views = getState().user.userInfo.views;

                    if (playSound(dispatch, pathname, product_id, views)) {
                        relatedTradedAudio.play();
                    }
                });

                socketClient.on('order_traded', (product_id) => {
                    const pathname = getState().routing.locationBeforeTransitions.pathname;
                    const views = getState().user.userInfo.views;

                    if (playSound(dispatch, pathname, product_id, views)) {
                        tradedAudio.play();
                    }
                });


                return next({ ...rest, socketClient, type: SUCCESS });
            })
            .catch(error => {
                return next({ ...rest, error, type: FAILURE });
            });
    };
}



// WEBPACK FOOTER //
// ./source/socket/socketMiddleware.js